//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules() {
  // no-op
}

export const states = {
  'facebook-oauth': StateFactory({
    url: '/facebook/oauth?code&state&granted_scopes',
    template: componentNameToTemplate('facebookOAuthResponse'),
    data: {
      title: 'Facebook OAuth',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/facebook.app')),
    },
  }),

  'google-oauth': StateFactory({
    url: '/google/oauth?code',
    template: componentNameToTemplate('googleOAuthResponse'),
    data: {
      title: 'Google OAuth',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/google.app')),
    },
  }),

  'pinterest-oauth': StateFactory({
    url: '/pinterest/oauth?code&state',
    template: componentNameToTemplate('pinterestOAuthResponse'),
    data: {
      title: 'Pinterest OAuth',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.app',
        () => import('app/oauth/pinterest.app'),
      ),
    },
  }),

  'tiktok-oauth': StateFactory({
    url: '/tiktok/oauth?code&state',
    template: componentNameToTemplate('tiktokOAuthPage'),
    data: {
      title: 'TikTok OAuth',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/OAuthApp')),
    },
  }),

  'tiktok-ads-oauth': StateFactory({
    url: '/tiktok-ads/oauth?code&state',
    template: componentNameToTemplate('tiktokAdsOAuthPage'),
    data: {
      title: 'TikTok Ads OAuth',
      navGroup: NavGroup.HOME,
      hasAccess: () => hasFeature(FeatureNames.TiktokSparkAds),
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/OAuthApp')),
    },
  }),

  'twitter-oauth': StateFactory({
    url: '/twitter/oauth?oauth_token&oauth_verifier',
    template: componentNameToTemplate('twitterOAuthResponse'),
    data: {
      title: 'X OAuth',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/twitter.app')),
    },
  }),

  'walmart-login': StateFactory({
    url: '/walmart/login',
    template: componentNameToTemplate('walmartLoginPage'),
    data: {
      title: 'Bazaarvoice Vibe',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/OAuthApp')),
    },
  }),

  'walmart-oauth': StateFactory({
    url: '/walmart/oauth?code&type&clientId&state&partnerId',
    template: componentNameToTemplate('walmartOAuthPage'),
    data: {
      title: 'Bazaarvoice Vibe',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/OAuthApp')),
    },
  }),

  'youtube-oauth': StateFactory({
    url: '/youtube/oauth?code&state&error',
    template: componentNameToTemplate('youtubeOAuthPage'),
    data: {
      title: 'YouTube OAuth',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule('curalate.app', () => import('app/oauth/OAuthApp')),
    },
  }),
};
